<script lang="ts">

    import { tweened } from 'svelte/motion';
    import { readable, writable } from 'svelte/store';

    const angle = tweened<number>(0);
    const isSpinning = writable<boolean>(false);
    const isFaceA = writable<boolean>(false);
    const isFaceB = writable<boolean>(false);
    const angleReadable = readable<number>(0, set => angle.subscribe(set));
    const isSpinningReadable = readable<boolean>(false, set => isSpinning.subscribe(set));
    const isFaceAReadable = readable<boolean>(false, set => isFaceA.subscribe(set));
    const isFaceBReadable = readable<boolean>(false, set => isFaceB.subscribe(set));

    let targetAngle = 0;

    angle.subscribe(angle => {
        const absAngle = Math.abs(angle) % 360;
        $isFaceB = absAngle > 90 && absAngle < 270;
        $isFaceA = !$isFaceB;
        $isSpinning = angle !== targetAngle;
    });

    export {
        angleReadable as angle,
        isSpinningReadable as isSpinning,
        isFaceAReadable as isFaceA,
        isFaceBReadable as isFaceB,
    };

    export function rotate(turns: number): void {
        targetAngle = $angle + (360 * turns);
        $angle = targetAngle;
    }

</script>

<style lang="scss">

    .revolving {
        width: 100%;
        height: 100%;
        perspective: 2000px;
    }

    .content {
        position: relative;
        width: 100%;
        height: 100%;
        transform-style: preserve-3d;
    }

    .face {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        backface-visibility: hidden;
        transform: translateZ(0.1px);

        &.face-b {
            transform: rotateY(180deg) translateZ(0.1px);
        }
    }

</style>

<div class="revolving">
    <div class="content" style="transform: rotateY({$angle}deg);">
        <div class="face face-a">
            <slot name="face-a"></slot>
        </div>
        <div class="face face-b">
            <slot name="face-b"></slot>
        </div>
    </div>
</div>
